export default {
  state: {
    dictionary: []
  }
}
